export default __webpack_public_path__ + "static/media/poster4.79a6b543.png";